export enum ChannelDetailAction {
  CREATE_AGENT = 'CREATE_AGENT',
}
